var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{staticClass:"d-none",attrs:{"id":"webcam","width":"200","height":"200","autoplay":""}}),_c('video',{staticClass:"d-none",attrs:{"id":"screen-sharing","width":"200","height":"200","autoplay":""}})])
}]

export { render, staticRenderFns }